// extracted by mini-css-extract-plugin
export default {"menuBlock":"oE-z","title":"pE-z","nav":"qE-z","flexCell":"rE-z","facetLink":"sE-z"};